import { DASHBOARD, DASHBOARD_FAILED, DASHBOARD_SUCCESS } from "./actionTypes";

let initialState = {
  dashboardData: {},
  loading: false,
  success: false,
  error: "",
};

export const dashboardReducer = (state = initialState, action) => { 
  switch (action.type) {
    case DASHBOARD:
      return {
        ...state,
        dashboardData: {},
        loading: true,
        success: false,
        error: "",
      };
    case DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload,
        loading: false,
        success: true,
        error: "",
      };
    case DASHBOARD_FAILED:
      return {
        ...state,
        dashboardData: {},
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
